export default __webpack_public_path__ + "static/media/icon_union_pay-grey.662a624c.png";